<template>
  <a-modal
    v-model:visible="state.drawer.visible"
    :title="state.drawer.title"
    width="40%"
    @ok="modalState.save"
  >
    <a-form
      ref="formRef"
      :rules="modalState.rules"
      :model="state.drawer"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-item label="消息类型组" name="groupCode">
        <a-select
          v-model:value="state.drawer.groupCode"
          :disabled="state.drawer.groupCodeSelectDisabled"
          placeholder="请选择"
          allow-clear
          show-search
          :options="state.messageTypeGroups"
          :filter-option="modalState.filterOption"
        >
        </a-select>
      </a-form-item>
      <a-form-item label="消息类型名称" name="messageTypeName">
        <a-input
          v-model:value="state.drawer.messageTypeName"
          allow-clear
          placeholder="请输入"
          :maxlength="50"
        />
      </a-form-item>
      <a-form-item label="消息等级" name="messageLevel">
        <a-radio-group v-model:value="state.drawer.messageLevel">
          <a-radio :value="10"><a-tag color="success">通知</a-tag></a-radio>
          <a-radio :value="20"><a-tag color="warning">警告</a-tag></a-radio>
          <a-radio :value="30"><a-tag color="error">错误</a-tag></a-radio>
        </a-radio-group>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { inject, reactive, ref } from 'vue'
import { edit_message_type } from 'server/modules/message'
import { message } from 'ant-design-vue'
export default {
  name: 'SiteMessageModal',
  setup() {
    const formRef = ref()
    const state = inject('state')
    const modalState = reactive({
      rules: {
        groupCode: [
          {
            required: true,
            message: '请选择消息类型组'
          }
        ],
        messageTypeName: [
          {
            required: true,
            message: '请输入消息类型名称'
          }
        ],
        messageLevel: [
          {
            required: true,
            message: '请选择消息等级'
          }
        ]
      },

      filterOption: (input, option) => {
        return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },

      save: () => {
        formRef.value.validate().then(async () => {
          const { success, retInfo } = await edit_message_type({
            groupCode: state.drawer.groupCode,
            messageTypeCode: state.drawer.messageTypeCode,
            messageTypeName: state.drawer.messageTypeName,
            level: state.drawer.messageLevel
          })

          if (success) {
            state.drawer.visible = false
            await state.getList()
          } else {
            message.error(retInfo)
          }
        })
      }
    })

    return {
      formRef,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      modalState,
      state
    }
  }
}
</script>

<style scoped></style>
